/**
 * Created by andrej on 3/16/17.
 */
import React from 'react';
import {Keys} from "../../model/constants/keys";
import RefreshIndicator from 'material-ui/RefreshIndicator'
import IconButton from 'material-ui/IconButton'
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';


const UpdatedInfo = (props) => {
    const {baseState, updateAction } = props
    const isUpdating = baseState.get(Keys.StoreSliceMeta.LOADING, false);
    const lastUpdate = baseState.get(Keys.StoreSliceMeta.LAST_LOAD_SUCCESS)
    const refreshStyle = {
        position:'relative',
        display:'inline-block',
        margin:4,

    };
    const buttonStyle = {
        position:'relative',
        display:'inline-block',
        // borderWidth:1,
        // borderStyle:'solid',
        // borderColor:'#ff0',
        padding:4,
        width:32,
        height:32,

    };
    const emptyStyle = {
        position:'relative',
        display:'inline-block',
        width:32,
        height:32,

    };
    const textStyle = {
        position:'relative',
        display:'inline-block',
        left:4

    };
    const getUpdateButton = () => {
        // return (<div style={{position:'relative', height:32, display:'inline-block'}}>
        //     <RefreshIndicator top={0} left={0} status="loading" style={refreshStyle} size={24}/>
        //     <IconButton tooltip="Refresh" onTouchTap={updateAction} style={buttonStyle}><RefreshIcon/></IconButton>
        //     <div className="update-info__empty-button" style={emptyStyle} ></div>
        // </div>)
        if( isUpdating ) {
            return (<RefreshIndicator top={0} left={0} status="loading" style={refreshStyle} size={24}/>)
        } else {
            if( updateAction ) {
                return (<IconButton tooltip="Refresh" onTouchTap={updateAction} style={buttonStyle}><RefreshIcon/></IconButton>)
            } else {
                return (<div className="update-info__empty-button" style={emptyStyle} ></div>)
            }

        }
    }

    return (
        <div className="update-info"><div style={{position:'relative', height:32}}>{getUpdateButton()}</div>
            <span style={textStyle}> Updated: {isUpdating?"..."
            :(lastUpdate?lastUpdate.toString():"")}
                    </span></div>
    )
}

export default UpdatedInfo;


// WEBPACK FOOTER //
// ./src/ui/components/UpdatedInfo.js